import React from "react";
import { connect } from "react-redux";

import {
  doGetAllCompanyAdmins,
  doCreateCompanyAdmin,
  doUpdateCompanyAdmin,
  doGetAllPartnerCompanyAdmins,
  doCreatePartnerCompanyAdmin,
  doUpdatePartnerCompanyAdmin,
} from "../stores/thunk";
import { selectAllCompanyAdmins } from "../stores/slice";
import { doGetAllCompanies, doGetAllPartnerCompanies } from "../../company/stores/thunk";
import { selectAllCompanies } from "../../company/stores/slice";
import { doSignIn } from "../../auth/stores/thunk";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.companyAdmin.isFetching,
      metadata: state.companyAdmin.metadata,
      companyAdmins: selectAllCompanyAdmins(state),
      companies: selectAllCompanies(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllCompanies,
    doGetAllCompanyAdmins,
    doCreateCompanyAdmin,
    doUpdateCompanyAdmin,
    doSignIn,
    doGetAllPartnerCompanies,
    doGetAllPartnerCompanyAdmins,
    doCreatePartnerCompanyAdmin,
    doUpdatePartnerCompanyAdmin,
  })(Container);
};
